import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ImgEditing from './imgediting';

export default class Img extends Plugin {
  static get requires() {
    return [ ImgEditing ];
  }

  static get pluginName() {
    return 'Img';
  }
}